// const BASE_API = process.env.BASE_URL
const BASE_API = "/api/";
const BASE_API_OLD = "";
// const BASE_API = ''
// 省内客流页面
let insideprovince = BASE_API + "travel/insideprovince/"; // 省内分析
// 外省页面
let demo = BASE_API + "travel/toC/mapDisplay/"; // demo
// 外省客流
let outProvince = BASE_API + "travel/outsideprovince/page";
let outsideprovince = BASE_API + "travel/outsideprovince/";
// 省内客流
let passengerFlow = BASE_API + "travel/northwestpassengerflow/page";
// 省外详情入甘游客排行榜
let getTouristRanking =
    BASE_API + "travel/northwestpassengerflow/touristRanking";
// 省外详情入甘车辆排行榜
let getCarRanking = BASE_API + "travel/northwestpassengerflow/carRanking";
// 省外详情出行态势感知
let getAwarenessList =
    BASE_API + "travel/northwestpassengerflow/situationalAwareness";
// 省外详情增长率
let getGrowthRate = BASE_API + "travel/northwestpassengerflow/growthRate";
// 省外详情总人数
let getTotal = BASE_API + "travel/northwestpassengerflow/entryTotal";
// 市州页面
let city = BASE_API + "travel/citypassengerflow/page";
// 市州右上角数据
let orderData = BASE_API + "travel/citypassengerflow/todayData";
// 市州内容云视频
let getContentCloud = BASE_API + "travel/citypassengerflow/contentCloud";
// 市州城市列表
let getCityList = BASE_API + "travel/citypassengerflow/cityList";
// 市州地图资源
let getMapResource = BASE_API + "travel/citypassengerflow/dataBelowMap";
// 市州地图数据
let getMapData = BASE_API + "travel/citypassengerflow/centerMap";
// 市州七日客流趋势
let getFlowTrend = BASE_API + "travel/citypassengerflow/passengerFlowTrend";
// 市州内容云统计
let getContentCount = BASE_API + "travel/citypassengerflow/contentQuantity";
const login = `${BASE_API}blade-auth/oauth/token`; // 登录API
const captcha = `${BASE_API}blade-auth/oauth/captcha`;
const videoAI = `${BASE_API}travel/videoAnalysis/monitoringPointInformation`; // 视频AI信息
const videoAIUrl = `${BASE_API}travel/videoAnalysis/video`; // 视频AI地址
const videoAiInfo = `${BASE_API}travel/videoAnalysis/alarmInformation`; // 报警信息
// 公路页面
let getHighList = BASE_API + "travel/toC/highwayTravel/page";
// 人数
let getHighwayOrderList = BASE_API + "travel/toC/highwayTravel/totalNumber";
// 客源地排行榜
let getHighwayTouristList = BASE_API + "travel/toC/highwayTravel/touristList";
// 收费站排行榜
let getHighwayStationList =
    BASE_API + "travel/toC/highwayTravel/tollStationList";
// 交通导航数据
let getLineTagList = BASE_API + "travel/toC/highwayTravel/topTag";
// 铁路页面
let geRailList = BASE_API + "travel/railtravel/page";
// 人数
let getRailwayOrderList = BASE_API + "travel/railtravel/totalNumber";
// 客源地排行榜
let getRailwayTouristList = BASE_API + "travel/railtravel/touristList";
// 收费站排行榜
let getRailwayStationList = BASE_API + "travel/railtravel/stationList";
// 航空页面
let getFlightList = BASE_API + "travel/toC/airTravel/page";
// 人数
let getFlightOrderList = BASE_API + "travel/toC/airTravel/exitEntryNumber";
// 客源地排行榜
let getFlightTouristList = BASE_API + "travel/toC/airTravel/airTouristList";
// 收费站排行榜
let getFlightStationList = BASE_API + "travel/toC/airTravel/airportList";
// 预约总数统计接口
// 景区详情left
let scenicLeftData = BASE_API + "travel/scenicspot/allData";
// 景区详情left
let scenicRightData = BASE_API + "travel/scenicspot/rightData";
// 景区详情left
let scenicList = BASE_API + "travel/scenicspot/scenicOrderNum";
// 景区详情right
let scenicSpot = BASE_API + "travel/allscenicspot/page"; // 景区专题
let scenicSpotDemo = BASE_API + "travel/allscenicspot/"; // 景区专题
let roadTrip = BASE_API + "travel/roadtrip/"; // 景区专题
// 获取目的地指数列表
const GET_DESTINATION_LIST = BASE_API + "travel/scatterdiagram/page";
// 获取目的地指数详情
const GET_DESTINATION_DETAIL = BASE_API + "travel/destinationindexdetails/page";
// 获取游客画像数据
const GET_TOURISTS_PORTRAIT_DATA = BASE_API + "travel/touristphotos/page";
//数据统计左侧树查询
const GET_DATA_TOTAL_TREE = BASE_API + "travel/toC/modularDict/page";
// 数据统计列表查询
const GET_DATA_TOTAL = BASE_API + "travel/toC/statistics/page";
// 登录C
const LOGIN_C = BASE_API + "travel/toC/displayUser/login";
//搜索接口
const GET_SEARCH = BASE_API + "travel/toC/search/page";
//树查询接口
//数据监测 接口
const HOLDDATA_TOPONE = BASE_API + "travel/interfaceMonitor/topOne";
const HOLDDATA_TOPTWO = BASE_API + "travel/interfaceMonitor/topTwo";
const HOLDDATA_MIDONE = BASE_API + "travel/interfaceMonitor/midOne";
const HOLDDATA_MIDTWO = BASE_API + "travel/interfaceMonitor/midTwo";
const HOLDDATA_MIDTHREE = BASE_API + "travel/interfaceMonitor/midThree";
const HOLDDATA_DOWNONE = BASE_API + "travel/interfaceMonitor/downOne";
const HOLDDATA_DOWNTWO = BASE_API + "travel/interfaceMonitor/downTwo";
const HOLDDATA_DOWNTHREE = BASE_API + "travel/interfaceMonitor/downThree";
//服务器监测接口
const SEVER_STATUS_MIDONE = BASE_API + "travel/serverStatus/topOne";
const SEVER_STATUS_MIDTWO = BASE_API + "travel/serverStatus/topTwo";
const SEVER_STATUS_BOTTOMTWO = BASE_API + "travel/serverStatus/downTwo";
const SEVER_STATUS_BOTTOMTHREE = BASE_API + "travel/serverStatus/downThree";
//数据目录接口
const DATA_DIRECTORY = BASE_API + "/travel/dataDirectory/customQuery";

const GET_TREE = BASE_API + "/blade-system/dict-biz/dictionary";
//知识库左侧树查询接口
const GET_KNOWLEDGE_TREE =
    "https://traveldata.yougansu.com/api/travel/modularDict/listTree";
//知识库数据查询
const GET_KNOWLEDGE_DATA =
    "https://traveldata.yougansu.com/api/travel/toC/knowledge/selectKnowledgeList";
//知识库 详情查询
const GET_KNOWLEDGE_EXPDETAIL =
    "https://traveldata.yougansu.com/api/travel/toC/knowledge/detail";
//统计数据
const GET_DATA_TOTALDETAIL = BASE_API + "travel/toC/statistics/detail";
//游客画像接口
//topOne
const GET_TOURIST_TOP_ONE = BASE_API + "travel/toC/touristPortrait/leftUpper";
//topTwo
const GET_TOURIST_TOP_TWO = BASE_API + "travel/toC/touristPortrait/middleUpper";
//topThree
const GET_TOURIST_TOP_THREE = BASE_API + "travel/toC/touristPortrait/rightUpper";
//bottomOne
const GET_TOURIST_BOTTOM_ONE = BASE_API + "travel/toC/touristPortrait/leftLower";
//bottomTwo
const GET_TOURIST_BOTTOM_TWO = BASE_API + "travel/toC/touristPortrait/middleLower";
//bottomThree
const GET_TOURIST_BOTTOM_THREE = BASE_API + "travel/toC/touristPortrait/rightLower";
//网络指数接口
//top
const GET_NETWORK_TOP = BASE_API + "travel/toC/networkIndex/upper";
//centerOne
const GET_NETWORK_CENTER_ONE = BASE_API + "travel/toC/networkIndex/leftUpper";
//centerTwo
const GET_NETWORK_CENTER_TWO = BASE_API + "travel/toC/networkIndex/rightUpper";
//bottomOne
const GET_NETWORK_BOTTOM_ONE = BASE_API + "travel/toC/networkIndex/leftLower";
//bottomTwo
const GET_NETWORK_BOTTOM_TWO = BASE_API + "travel/toC/networkIndex/rightLower";
//周边游客分析接口
//tagsList
const GET_SURROUND_TAGSLIST = BASE_API + "travel/toC/surrounding/leftUpper";
//tourList
const GET_SURROUND_TOURLIST = BASE_API + "travel/toC/surrounding/leftMiddle";
//typeOption
const GET_SURROUND_TYPEOPTION = BASE_API + "travel/toC/surrounding/leftLower";
//centerMap
const GET_SURROUND_CENTERMAP = BASE_API + "travel/toC/surrounding/map";
//hotLine
const GET_SURROUND_HOTLINE = BASE_API + "travel/toC/surrounding/rightUpper";
//tourSource
const GET_SURROUND_TOURSOURCE = BASE_API + "travel/toC/surrounding/rightMiddle";
//dwellTime
const GET_SURROUND_DWELLTIME = BASE_API + "travel/toC/surrounding/rightLower";
//住宿专题接口
let housingProject = BASE_API + "travel/toC/hotel/";
// upper
const HOUSE_TOP_DATA = BASE_API + "travel/toC/hotel/upper";
// leftUpper
const HOUSE_HOTEL_LIST = BASE_API + "travel/toC/hotel/leftUpper";
// middleUpper
const HOUSE_HOTEL_PREFERENCE = BASE_API + "travel/toC/hotel/middleUpper";
// leftLower
const HOUSE_GOOD_HOTEL = BASE_API + "travel/toC/hotel/leftLower";
// middleLower
const HOUSE_WORD_CLOUD = BASE_API + "travel/toC/hotel/middleLower";
// rightUpper
const HOUSE_PASSENGER_FLOW = BASE_API + "travel/toC/hotel/rightUpper";
//rightLower
const HOUSE_HOTEL_PRICE = BASE_API + "travel/toC/hotel/rightLower";
// 景区专题接口
const SCENIC_SPOT = BASE_API + "travel/toC/scenicSpot"
// 景区专题列表
const SCENIC_SPOT_LEFT = BASE_API + "travel/toC/scenicSpot/left"
// 景区专题地图
const SCENIC_SPOT_MAP = BASE_API + "travel/toC/scenicSpot/map"
// 景区专题周客流对比
const SCENIC_SPOT_RIGHT_UPPER = BASE_API + "travel/toC/scenicSpot/rightUpper"
// 景区专题客流趋势
const SCENIC_SPOT_RIGHT_MIDDLE = BASE_API + "travel/toC/scenicSpot/rightMiddle"
// 景区专题省内客源分布
const SCENIC_SPOT_RIGHT_LOWER_ONE = BASE_API + "travel/toC/scenicSpot/rightLowerOne"
// 景区专题省外客源分布
const SCENIC_SPOT_RIGHT_LOWER_TWO = BASE_API + "travel/toC/scenicSpot/rightLowerTwo"
// 视频AI分析
const VIDEO_ANALYSIS = BASE_API + "travel/toC/camera"
// 景区客流分析
const VIDEO_ANALYSIS_LEFT_UPPER = BASE_API + "travel/toC/camera/leftUpper"
// 视频流
const VIDEO_ANALYSIS_REAL_MONITOR = BASE_API + "travel/toC/camera/realMonitor"
// 图集
const VIDEO_ANALYSIS_LEFT_LOWER = BASE_API + "travel/toC/camera/leftLower"
// 入园时间平均分布
const VIDEO_ANALYSIS_MIDDLE_UPPER = BASE_API + "travel/toC/camera/middleUpper"
// 入园游客分布
const VIDEO_ANALYSIS_MIDDLE_LOWER = BASE_API + "travel/toC/camera/middleLower"
// 东门实时客流
const VIDEO_ANALYSIS_RIGHT_UPPER = BASE_API + "travel/toC/camera/rightUpper"
// 游客性别占比
const VIDEO_ANALYSIS_RIGHT_MIDDLE = BASE_API + "travel/toC/camera/rightMiddle"
// 游客年龄占比
const VIDEO_ANALYSIS_RIGHT_LOWER = BASE_API + "travel/toC/camera/rightLower"
// 夜经济专题
const NIGHT_ECONOMY = BASE_API + "travel/toC/nightEconomy"
// 景区资源分布
const NIGHT_ECONOMY_LEFT_UPPER = BASE_API + "travel/toC/nightEconomy/leftUpper"
// 夜间旅游花费
const NIGHT_ECONOMY_LEFT_LOWER = BASE_API + "travel/toC/nightEconomy/leftLower"
// 夜间旅游停留时间
const NIGHT_ECONOMY_MIDDLE_UPPER = BASE_API + "travel/toC/nightEconomy/middleUpper"
// 夜间市场满意度
const NIGHT_ECONOMY_MIDDLE_LOWER = BASE_API + "travel/toC/nightEconomy/middleLower"
// 宣传片
const NIGHT_ECONOMY_RIGHT_UPPER = BASE_API + "travel/toC/nightEconomy/rightUpper"
// 夜间体验活动
const NIGHT_ECONOMY_RIGHT_LOWER = BASE_API + "travel/toC/nightEconomy/rightLower"
// 旅游资源分析
const CULTURAL_TOURISM = BASE_API + "travel/toC/culturalTourism"
// 花产业资源
const CULTURAL_TOURISM_LEFT_UPPER = BASE_API + "travel/toC/culturalTourism/leftUpper"
// 在建文旅项目
const CULTURAL_TOURISM_LEFT_LOWER = BASE_API + "travel/toC/culturalTourism/leftLower"
// 非物质文化遗产
const CULTURAL_TOURISM_MIDDLE_UPPER = BASE_API + "travel/toC/culturalTourism/middleUpper"
// 文旅产业资源
const CULTURAL_TOURISM_MIDDLE_LOWER = BASE_API + "travel/toC/culturalTourism/middleLower"
// 非遗传承人
const CULTURAL_TOURISM_RIGHT = BASE_API + "travel/toC/culturalTourism/right"
// 综合分析接口
const CITY_ANALYSIS = BASE_API + "travel/toC/analysis"
// 累计接待量
const CITY_ANALYSIS_LEFT_UPPER = BASE_API + "travel/toC/analysis/leftUpper"
// 新老游客对比
const CITY_ANALYSIS_LEFT_LOWER = BASE_API + "travel/toC/analysis/leftLower"
// 客源地城市
const CITY_ANALYSIS_MIDDLE_UPPER = BASE_API + "travel/toC/analysis/middleUpper"
// 搜索指数排名
const CITY_ANALYSIS_MIDDLE_LOWER = BASE_API + "travel/toC/analysis/middleLower"
// 性别占比
const CITY_ANALYSIS_RIGHT_UPPER = BASE_API + "travel/toC/analysis/rightUpper"
// 年龄占比
const CITY_ANALYSIS_RIGHT_MIDDLE = BASE_API + "travel/toC/analysis/rightMiddle"
// 客源地省份
const CITY_ANALYSIS_RIGHT_LOWER = BASE_API + "travel/toC/analysis/rightLower"
// 景区综合分析页面
const SPOT_DISPLAY = BASE_API + "travel/toC/spotcomprehensive"
// 顶部翻牌
const SPOT_DISPLAY_LEFT_UPPER = BASE_API + "travel/toC/spotcomprehensive/leftUpper"
// 客源地TOP5
const SPOT_DISPLAY_LEFT_LOWER = BASE_API + "travel/toC/spotcomprehensive/leftLower"
// 景区游客图像
const SPOT_DISPLAY_MIDDLE_UPPER = BASE_API + "travel/toC/spotcomprehensive/middleUpper"
// 今日景区客流趋势分析
const SPOT_DISPLAY_MIDDLE_MIDDLE = BASE_API + "travel/toC/spotcomprehensive/middleMiddle"
// 近7天景区客流统计
const SPOT_DISPLAY_MIDDLE_LOWER = BASE_API + "travel/toC/spotcomprehensive/middleLower"
// 实时客流监测
const SPOT_DISPLAY_RIGHT_UPPER = BASE_API + "travel/toC/spotcomprehensive/rightUpper"
// 周客流对比
const SPOT_DISPLAY_RIGHT_MIDDLE = BASE_API + "travel/toC/spotcomprehensive/rightMiddle"
// 近3个月接待游客
const SPOT_DISPLAY_RIGHT_LOWER = BASE_API + "travel/toC/spotcomprehensive/rightLower"
// 今日票务分析
const TICKET_TODAY = BASE_API + "travel/toC/tickettoday"
// 今日票务总览
const TICKET_TODAY_LEFT_UPPER = BASE_API + "travel/toC/tickettoday/leftUpper"
// 售票渠道统计
const TICKET_TODAY_LEFT_LOWER = BASE_API + "travel/toC/tickettoday/leftLower"
// 今日检票/退票分析
const TICKET_TODAY_MIDDLE_UPPER = BASE_API + "travel/toC/tickettoday/middleUpper"
// 今日检票入园客流分析
const TICKET_TODAY_MIDDLE_LOWER = BASE_API + "travel/toC/tickettoday/middleLower"
// 今日票务结算分布
const TICKET_TODAY_RIGHT_UPPER = BASE_API + "travel/toC/tickettoday/rightUpper"
// 今日票种分布
const TICKET_TODAY_RIGHT_LOWER = BASE_API + "travel/toC/tickettoday/rightLower"
// 票务分析
const TICKET_ANALYSIS = BASE_API + "travel/toC/ticketcomprehensive"
// 营业额总览
const TICKET_ANALYSIS_LEFT_UPPER = BASE_API + "travel/toC/ticketcomprehensive/leftUpper"
// 售票数量统计
const TICKET_ANALYSIS_LEFT_LOWER = BASE_API + "travel/toC/ticketcomprehensive/leftLower"
// 近7日检票统计
const TICKET_ANALYSIS_MIDDLE_UPPER = BASE_API + "travel/toC/ticketcomprehensive/middleUpper"
// 月度售票趋势
const TICKET_ANALYSIS_MIDDLE_LOWER = BASE_API + "travel/toC/ticketcomprehensive/middleLower"
// 近7日票种分析
const TICKET_ANALYSIS_RIGHT_UPPER = BASE_API + "travel/toC/ticketcomprehensive/rightUpper"
// 本月平均检票时段分析
const TICKET_ANALYSIS_RIGHT_LOWER = BASE_API + "travel/toC/ticketcomprehensive/rightLower"
// 景区游客画像接口
const SPOT_TOURIST_PORTRAIT = BASE_API + "travel/toC/spottouristportrait"
// 游客年龄比例
const SPOT_TOURIST_PORTRAIT_LEFT_UPPER = BASE_API + "travel/toC/spottouristportrait/leftUpper"
// 游客性别比例
const SPOT_TOURIST_PORTRAIT_LEFT_LOWER = BASE_API + "travel/toC/spottouristportrait/leftLower"
// 国内客源地TOP10
const SPOT_TOURIST_PORTRAIT_MIDDLE = BASE_API + "travel/toC/spottouristportrait/middle"
// 省内客源地TOP10
const SPOT_TOURIST_PORTRAIT_RIGHT = BASE_API + "travel/toC/spottouristportrait/right"
// 小程序使用情况接口
const MINI_PROGRAM_USAGE = BASE_API + "travel/toC/miniprogramusage"
// 用户数量及访问量
const MINI_PROGRAM_USAGE_LEFT_UPPER = BASE_API + "travel/toC/miniprogramusage/leftUpper"
// 用户分享
const MINI_PROGRAM_USAGE_LEFT_LOWER = BASE_API + "travel/toC/miniprogramusage/leftLower"
// 本月用户活跃度
const MINI_PROGRAM_USAGE_MIDDLE_UPPER = BASE_API + "travel/toC/miniprogramusage/middleUpper"
// 每日平均访问时段
const MINI_PROGRAM_USAGE_MIDDLE_LOWER = BASE_API + "travel/toC/miniprogramusage/middleLower"
// 导游导览点位热度
const MINI_PROGRAM_USAGE_RIGHT_UPPER = BASE_API + "travel/toC/miniprogramusage/rightUpper"
// 用户浏览喜好
const MINI_PROGRAM_USAGE_RIGHT_LOWER = BASE_API + "travel/toC/miniprogramusage/rightLower"
const path = {
    captcha,
    videoAiInfo,
    videoAIUrl,
    videoAI,
    login,
    scenicSpotDemo,
    roadTrip,
    scenicSpot,
    housingProject,
    city,
    outProvince,
    passengerFlow,
    getTouristRanking,
    getCarRanking,
    getAwarenessList,
    getGrowthRate,
    getTotal,
    demo,
    orderData,
    getContentCloud,
    getCityList,
    getMapResource,
    getMapData,
    getFlowTrend,
    getContentCount,
    outsideprovince,
    insideprovince,
    getHighList,
    geRailList,
    getFlightList,
    getHighwayOrderList,
    getHighwayTouristList,
    getHighwayStationList,
    getRailwayOrderList,
    getRailwayTouristList,
    getRailwayStationList,
    getFlightOrderList,
    getFlightTouristList,
    getFlightStationList,
    getLineTagList,
    scenicLeftData,
    scenicRightData,
    scenicList,
    GET_DESTINATION_LIST,
    GET_DESTINATION_DETAIL,
    GET_TOURISTS_PORTRAIT_DATA,
    GET_DATA_TOTAL,
    GET_SEARCH,
    LOGIN_C,
    GET_TREE,
    GET_DATA_TOTAL_TREE,
    HOLDDATA_TOPONE,
    HOLDDATA_TOPTWO,
    HOLDDATA_MIDONE,
    HOLDDATA_MIDTWO,
    HOLDDATA_MIDTHREE,
    HOLDDATA_DOWNONE,
    HOLDDATA_DOWNTWO,
    HOLDDATA_DOWNTHREE,
    GET_KNOWLEDGE_TREE,
    GET_KNOWLEDGE_DATA,
    GET_KNOWLEDGE_EXPDETAIL,
    GET_DATA_TOTALDETAIL,
    SEVER_STATUS_MIDONE,
    SEVER_STATUS_MIDTWO,
    SEVER_STATUS_BOTTOMTWO,
    SEVER_STATUS_BOTTOMTHREE,
    DATA_DIRECTORY,
    GET_TOURIST_TOP_ONE,
    GET_TOURIST_TOP_TWO,
    GET_TOURIST_TOP_THREE,
    GET_TOURIST_BOTTOM_ONE,
    GET_TOURIST_BOTTOM_TWO,
    GET_TOURIST_BOTTOM_THREE,
    GET_NETWORK_TOP,
    GET_NETWORK_CENTER_ONE,
    GET_NETWORK_CENTER_TWO,
    GET_NETWORK_BOTTOM_ONE,
    GET_NETWORK_BOTTOM_TWO,
    GET_SURROUND_TAGSLIST,
    GET_SURROUND_TOURLIST,
    GET_SURROUND_TYPEOPTION,
    GET_SURROUND_CENTERMAP,
    GET_SURROUND_HOTLINE,
    GET_SURROUND_TOURSOURCE,
    GET_SURROUND_DWELLTIME,
    HOUSE_TOP_DATA,
    HOUSE_HOTEL_LIST,
    HOUSE_HOTEL_PREFERENCE,
    HOUSE_GOOD_HOTEL,
    HOUSE_WORD_CLOUD,
    HOUSE_PASSENGER_FLOW,
    HOUSE_HOTEL_PRICE,
    SCENIC_SPOT,
    SCENIC_SPOT_LEFT,
    SCENIC_SPOT_MAP,
    SCENIC_SPOT_RIGHT_UPPER,
    SCENIC_SPOT_RIGHT_MIDDLE,
    SCENIC_SPOT_RIGHT_LOWER_ONE,
    SCENIC_SPOT_RIGHT_LOWER_TWO,
    VIDEO_ANALYSIS,
    VIDEO_ANALYSIS_LEFT_UPPER,
    VIDEO_ANALYSIS_REAL_MONITOR,
    VIDEO_ANALYSIS_LEFT_LOWER,
    VIDEO_ANALYSIS_MIDDLE_UPPER,
    VIDEO_ANALYSIS_MIDDLE_LOWER,
    VIDEO_ANALYSIS_RIGHT_UPPER,
    VIDEO_ANALYSIS_RIGHT_MIDDLE,
    VIDEO_ANALYSIS_RIGHT_LOWER,
    NIGHT_ECONOMY,
    NIGHT_ECONOMY_LEFT_UPPER,
    NIGHT_ECONOMY_LEFT_LOWER,
    NIGHT_ECONOMY_MIDDLE_UPPER,
    NIGHT_ECONOMY_MIDDLE_LOWER,
    NIGHT_ECONOMY_RIGHT_UPPER,
    NIGHT_ECONOMY_RIGHT_LOWER,
    CULTURAL_TOURISM,
    CULTURAL_TOURISM_LEFT_UPPER,
    CULTURAL_TOURISM_LEFT_LOWER,
    CULTURAL_TOURISM_MIDDLE_UPPER,
    CULTURAL_TOURISM_MIDDLE_LOWER,
    CULTURAL_TOURISM_RIGHT,
    CITY_ANALYSIS,
    CITY_ANALYSIS_LEFT_UPPER,
    CITY_ANALYSIS_LEFT_LOWER,
    CITY_ANALYSIS_MIDDLE_UPPER,
    CITY_ANALYSIS_MIDDLE_LOWER,
    CITY_ANALYSIS_RIGHT_UPPER,
    CITY_ANALYSIS_RIGHT_MIDDLE,
    CITY_ANALYSIS_RIGHT_LOWER,
    SPOT_DISPLAY,
    SPOT_DISPLAY_LEFT_UPPER,
    SPOT_DISPLAY_LEFT_LOWER,
    SPOT_DISPLAY_MIDDLE_UPPER,
    SPOT_DISPLAY_MIDDLE_MIDDLE,
    SPOT_DISPLAY_MIDDLE_LOWER,
    SPOT_DISPLAY_RIGHT_UPPER,
    SPOT_DISPLAY_RIGHT_MIDDLE,
    SPOT_DISPLAY_RIGHT_LOWER,
    TICKET_TODAY,
    TICKET_TODAY_LEFT_UPPER,
    TICKET_TODAY_LEFT_LOWER,
    TICKET_TODAY_MIDDLE_UPPER,
    TICKET_TODAY_MIDDLE_LOWER,
    TICKET_TODAY_RIGHT_UPPER,
    TICKET_TODAY_RIGHT_LOWER,
    TICKET_ANALYSIS,
    TICKET_ANALYSIS_LEFT_UPPER,
    TICKET_ANALYSIS_LEFT_LOWER,
    TICKET_ANALYSIS_MIDDLE_UPPER,
    TICKET_ANALYSIS_MIDDLE_LOWER,
    TICKET_ANALYSIS_RIGHT_UPPER,
    TICKET_ANALYSIS_RIGHT_LOWER,
    SPOT_TOURIST_PORTRAIT,
    SPOT_TOURIST_PORTRAIT_LEFT_UPPER,
    SPOT_TOURIST_PORTRAIT_LEFT_LOWER,
    SPOT_TOURIST_PORTRAIT_MIDDLE,
    SPOT_TOURIST_PORTRAIT_RIGHT,
    MINI_PROGRAM_USAGE,
    MINI_PROGRAM_USAGE_LEFT_UPPER,
    MINI_PROGRAM_USAGE_LEFT_LOWER,
    MINI_PROGRAM_USAGE_MIDDLE_UPPER,
    MINI_PROGRAM_USAGE_MIDDLE_LOWER,
    MINI_PROGRAM_USAGE_RIGHT_UPPER,
    MINI_PROGRAM_USAGE_RIGHT_LOWER
};

export default path;



// WEBPACK FOOTER //
// ./src/url.js